module.exports = __webpack_public_path__ + "static/media/S2N1-2.5ac3f1f4.svg";